const topTickerSymbols = [
  'SWVXX',
  'AAPL',
  'NVDA',
  'MSFT',
  'AMZN',
  'GOOGL',
  'VOO',
  'QQQ',
  'META',
  'VTI',
  'TSLA',
  'SPY',
  'XOM',
  'JPM',
  'JNJ',
  'AVGO',
  'SWPPX',
  'BRK.B',
  'VEA',
  'DIS',
  'COST',
  'CVX',
  'VZ',
  'V',
  'HD',
  'GOOG',
  'WMT',
  'SCHD',
  'T',
  'AMD',
  'SPAXX',
  'PG',
  'PFE',
  'VWO',
  'SCHF',
  'IVV',
  'CSCO',
  'INTC',
  'MRK',
  'LLY',
  'SNVXX',
  'ABBV',
  'SCHX',
  'UNH',
  'FXAIX',
  'PEP',
  'BAC',
  'KO',
  'NFLX',
  'ORCL',
  'SCHA',
  'IBM',
  'SBUX',
  'CRM',
  'IJR',
  'MA',
  'ADBE',
  'MCD',
  'BND',
  'F',
  'SCHH',
  'ABT',
  'FDRXX',
  'RTX',
  'VB',
  'NKE',
  'VUG',
  'QCOM',
  'BA',
  'FNDF',
  'SIRI',
  'TSM',
  'CAT',
  'IEMG',
  'CRWD',
  'GE',
  'VTV',
  'NEE',
  'MO',
  'TMO',
  'FNDX',
  'VNQ',
  'CMCSA',
  'PLTR',
  'SCHE',
  'AGG',
  'LMT',
  'PIMIX',
  'VIG',
  'AXP',
  'FNDA',
  'PYPL',
  'AMGN',
  'MS',
  'MDT',
  'NOW',
  'UPS',
  'SCHW',
  'WBD',
  'VMFXX',
  'SNSXX',
  'C',
  'INTU',
  'COP',
  'ACN',
  'VCIT',
  'BMY',
  'SCHP',
  'PANW',
  'VFIAX',
  'AMAT',
  'VO',
  'GLD',
  'XLE',
  'CMG',
  'XLK',
  'BNDX',
  'SCHG',
  'GEV',
  'TXN',
  'CVS',
  'IJH',
  'XLV',
  'UBER',
  'ASML',
  'PM',
  'GS',
  'XLF',
  'WFC',
  'BLK',
  'LOW',
  'SNOXX',
  'UNP',
  'DUK',
  'HON',
  'TGT',
  'GEHC',
  'ISRG',
  'MU',
  'SO',
  'SCHC',
  'VBR',
  'VGT',
  'SPLG',
  'VMBS',
  'ETN',
  'IWM',
  'FNDE',
  'DHR',
  'O',
  'VYM',
  'MBB',
  'LRCX',
  'TJX',
  'SCHR',
  'SCHB',
  'KMI',
  'DE',
  'SYK',
  'FNDC',
  'MDLZ',
  'SCHI',
  'JEPI',
  'IEFA',
  'MMM',
  'HAUZ',
  'VTSAX',
  'VXUS',
  'NVO',
  'FCX',
  'USHY',
  'SPYG',
  'SPSM',
  'SHOP',
  'TLT',
  'BX',
  'XLP',
  'DELL',
  'AMT',
  'XLU',
  'ZTS',
  'SWTSX',
  'RIVN',
  'BKNG',
  'LIN',
  'GILD',
  'TMUS',
  'BP',
  'DOW',
  'SPGI',
  'EBND',
  'GD',
  'SPYV',
  'AZN',
  'BABA',
  'ANET',
  'OXY',
  'ABNB',
  'EPD',
  'QUAL',
  'BTC',
  'CCL',
  'GM',
  'WM',
  'RSP',
  'SCHM',
  'VTRS',
  'LULU',
  'ET',
  'SHEL',
  'BSX',
  'TFC',
  'BSV',
  'KVUE',
  'ITOT',
  'PLD',
  'PSX',
  'PGR',
  'SMCI',
  'ENB',
  'ADI',
  'DD',
  'VRTX',
  'ITW',
  'ADP',
  'JPST',
  'SPMD',
  'SQ',
  'SLB',
  'MELI',
  'CCI',
  'VGLT',
  'JEPQ',
  'COF',
  'COIN',
  'EMB',
  'QQQM',
  'USB',
  'DVN',
  'VCSH',
  'KHC',
  'QACDS',
  'EMR',
  'CB',
  'VTEB',
  'FDX',
  'XLI',
  'VGIT',
  'CI',
  'SNOW',
  'VTIP',
  'MUB',
  'IEF',
  'SPDW',
  'DAL',
  'SWISX',
  'TTD',
  'SMH',
  'GIS',
  'PRU',
  'EW',
  'VRT',
  'IAU',
  'REGN',
  'AEP',
  'CSX',
  'AVUV',
  'FI',
  'PH',
  'WMB',
  'DODIX',
  'SNPS',
  'CL',
  'EOG',
  'AJG',
  'PNC',
  'CMI',
  'BDX',
  'OKE',
  'IBIT',
  'XLY',
  'KMB',
  'MCK',
  'ICE',
  'RIO',
  'JCI',
  'NOC',
  'GSK',
  'WBA',
  'APD',
  'SGOV',
  'BIL',
  'SPG',
  'VBK',
  'VLO',
  'XLRE',
  'DKNG',
  'DGRO',
  'UL',
  'ELV',
  'FTNT',
  'SHW',
  'SPEM',
  'CARR',
  'BRKB',
  'SYY',
  'VOE',
  'TTE',
  'XLC',
  'NEM',
  'FSPSX',
  'TRV',
  'DIA',
  'DFCEX',
  'CEG',
  'EFA',
  'VNQI',
  'SPTL',
  'NXPI',
  'WAB',
  'ARCC',
  'SNXFX',
  'KLAC',
  'GLW',
  'VBTLX',
  'MMC',
  'STZ',
  'VLTO',
  'CDNS',
  'LHX',
  'MRNA',
  'PFF',
  'DHI',
  'NSRGY',
  'ULTA',
  'WEC',
  'IWF',
  'HPE',
  'SOLV',
  'HSY',
  'SOFI',
  'MPC',
  'CTVA',
  'BHP',
  'BAGIX',
  'ETH',
  'D',
  'IVW',
  'HPQ',
  'MRVL',
  'TTWO',
  'CME',
  'MCHP',
  'EMXC',
  'TT',
  'PSA',
  'HYLB',
  'AGNC',
  'LUV',
  'VEU',
  'NVS',
  'BK',
  'KR',
  'AFL',
  'APH',
  'SNAP',
  'NLY',
  'GSIMX',
  'SONY',
  'TM',
  'DODGX',
  'MET',
  'CTAS',
  'SPIB',
  'VSS',
  'GPC',
  'SE',
  'PWR',
  'LQD',
  'SCYB',
  'FAST',
  'NSC',
  'BBCA',
  'PAYX',
  'ZS',
  'SCHZ',
  'GDX',
  'EFV',
  'ALB',
  'MFRS',
  'BIV',
  'DXCM',
  'ADSK',
  'ARE',
  'VT',
  'VGSH',
  'HCA',
  'EFG',
  'DLR',
  'HAL',
  'MSI',
  'IR',
  'COWZ',
  'OGN',
  'OTIS',
  'GOVT',
  'FIS',
  'ECL',
  'SCHV',
  'IRM',
  'SWSSX',
  'AAL',
  'DG',
  'ROK',
  'NUE',
  'COR',
  'RHHBY',
  'BBAX',
  'KKR',
  'IAGG',
  'BBJP',
  'ORLY',
  'ALL',
  'BUD',
  'SRE',
  'IEI',
  'VGK',
  'DOGE',
  'APP',
  'ARM',
  'HOOD',
  'XEL',
  'IGIB',
  'VWOB',
  'SLV',
  'PCAR',
  'IVE',
  'EQIX',
  'PXH',
  'LCID',
  'MNST',
  'SHY',
  'STIP',
  'RCL',
  'LVS',
  'PPG',
  'ZM',
  'SAP',
  'RBLX',
  'BIIB',
  'TIP',
  'ED',
  'HLT',
  'BBEU',
  'IWD',
  'SPMB',
  'VHT',
  'FSCJX',
  'MSTR',
  'IYW',
  'MAR',
  'MGK',
  'CNQ',
  'WDC',
  'U',
  'DFSVX',
  'FCNTX',
  'AVDV',
  'HBAN',
  'NIO',
  'EMLC',
  'ADM',
  'CAH',
  'DFISX',
  'FSPWX',
  'DEO',
  'CTRA',
  'SNY',
  'HUM',
  'DDOG',
  'TQQQ',
  'EQT',
  'YUM',
  'LEN',
  'DFAC',
  'ENPH',
  'AVEM',
  'ETR',
  'ARKK',
  'ON',
  'QDERQ',
  'FANG',
  'XLG',
  'VICI',
  'DFIEX',
  'TDG',
  'VIMAX',
  'ODFL',
  'TSCO',
  'SFLNX',
  'HUBS',
  'BCOIX',
  'JDEUX',
  'GOLD',
  'PRBLX',
  'EL',
  'RSG',
  'VTIAX',
  'URI',
  'OKTA',
  'XLB',
  'EWJ',
  'VONG',
  'VOT',
  'LYB',
  'ES',
  'WELL',
  'SDY',
  'SOXX',
  'SPOT',
  'ING',
  'ROP',
  'VOOG',
  'EBAY',
  'PINS',
  'HLN',
  'DFLVX',
  'MCO',
  'VSMAX',
  'PHM',
  'BTI',
  'CNC',
  'VV',
  'DOV',
  'MDB',
  'XT',
  'NCLH',
  'EA',
  'PDBZX',
  'IDXX',
  'SNAXX',
  'ILMN',
  'WYNN',
  'IWN',
  'DODFX',
  'CPRT',
  'OMC',
  'VDIGX',
  'HWM',
  'BBY',
  'VEIRX',
  'PEG',
  'MLM',
  'FTEC',
  'DFIV',
  'IQV',
  'TEAM',
  'QAJDS',
  'VEEV',
  'USFR',
  'DFS',
  'EIX',
  'SCHO',
  'FSLR',
  'QYLD',
  'A',
  'CLX',
  'VIGAX',
  'FSKAX',
  'CFG',
  'SCZ',
  'EXC',
  'ROST',
  'VXF',
  'DOC',
  'BKLN',
  'TROW',
  'UAL',
  'EXPE',
  'DASH',
  'KOMP',
  'WDAY',
  'TEL',
  'TER',
  'DOCU',
  'SWKS',
  'GRMN',
  'PHYZX',
  'KD',
  'LVMUY',
  'FXNAX',
  'NET',
  'SJM',
  'DISVX',
  'USMV',
  'VRSK',
  'CRDOX',
  'AME',
  'AI',
  'AES',
  'VWIUX',
  'SHV',
  'CTSH',
  'IGSB',
  'SPHQ',
  'AIG',
  'AXON',
  'CUSUX',
  'DFAS',
  'STX',
  'LUMN',
  'PATH',
  'APO',
  'CIUEX',
  'LNG',
  'PAYC',
  'DNA',
  'MPWR',
  'GME',
  'DGRW',
  'IUSB',
  'SPSB',
  'GIBIX',
  'WPC',
  'SPMO',
  'CINF',
  'WSO',
  'SWAGX',
  'JAAA',
  'ROKU',
  'FBGRX',
  'ACGL',
  'AVB',
  'MINT',
  'AZO',
  'MPW',
  'BIDU',
  'DFAI',
  'SOUN',
  'PDI',
  'IQLT',
  'AON',
  'NTAP',
  'GBTC',
  'GPN',
  'FBND',
  'IWO',
  'DJT',
  'SWK',
  'XBI',
  'VST',
  'BCE',
  'QCPCM',
  'BKR',
  'FICO',
  'BSIIX',
  'MSCI',
  'PCG',
  'MTB',
  'CSGP',
  'TRBCX',
  'MTUM',
  'QBERQ',
  'FSSNX',
  'DFAT',
  'RMD',
  'AEM',
  'IWR',
  'GWW',
  'KDP',
  'CAVA',
  'PPL',
  'VDE',
  'CAG',
  'MIEKX',
  'KEYS',
  'SIEGY',
  'DFGEX',
  'IXUS',
  'IP',
  'AWK',
  'FITB',
  'FSRJX',
  'BLDR',
  'RITM',
  'SPTI',
  'MOAT',
  'VTABX',
  'PLUG',
  'NICE',
  'AGTHX',
  'SYF',
  'NDAQ',
  'MRO',
  'ETSY',
  'TRGP',
  'SAN',
  'AMP',
  'MAIN',
  'XMHQ',
  'DBLTX',
  'HYG',
  'AMC',
  'SCHK',
  'ASTS',
  'HIG',
  'ISNPY',
  'RERGX',
  'VYMI',
  'LW',
  'KEY',
  'CELH',
  'WY',
  'FSMDX',
  'USRT',
  'DYNF',
  'DUHP',
  'CCLFX',
  'DFSCX',
  'CHWY',
  'CHTR',
  'PRF',
  'VIIIX',
  'TOELY',
  'DFAE',
  'LH',
  'SBAC',
  'BAH',
  'DFSTX',
  'SPTM',
  'ABR',
  'CGLBX',
  'APTV',
  'MGM',
  'FE',
  'IT',
  'APA',
  'WDS',
  'DHLGY',
  'LRLCY',
  'MULN',
  'DFUV',
  'VTR',
  'SFNNX',
  'VMC',
  'PDD',
  'IWP',
  'DFIVX',
  'MTCH',
  'VTWO',
  'DFGBX',
  'SPLV',
  'EVRG',
  'NRG',
  'CDDYX',
  'VPU',
  'TLH',
  'IFRA',
  'BR',
  'MKFG',
  'SOXL',
  'HMC',
  'CBRE',
  'TSN',
  'EEM',
  'ISPC',
  'BAX',
  'CHD',
  'FERG',
  'PRDGX',
  'PONAX',
  'MKC',
  'FTV',
  'NU',
  'VIGI',
  'NOK',
  'NVVE',
  'RF',
  'JD',
  'AMLP',
  'TLRY',
  'PRFZ',
  'MOS',
  'VFSUX',
  'WCN',
  'PARA',
  'EXR',
  'TWLO',
  'DIHP',
  'OVV',
  'CBOE',
  'ABBNY',
  'SPYD',
  'PPA',
  'EMN',
  'OLED',
  'APHKX',
  'INDA',
  'CALF',
  'SBGSY',
  'BLV',
  'ZBH',
  'NOBL',
  'FBTC',
  'HES',
  'FAX',
  'KNSL',
  'IFF',
  'DFIC',
  'XYL',
  'CDW',
  'VWILX',
  'MPLX',
  'BITO',
  'CMS',
  'CLF',
  'DTE',
  'PSTG',
  'IWS',
  'TEVA',
  'MARA',
  'J',
  'DVY',
  'JLGMX',
  'AKAM',
  'HDV',
  'CSRSX',
  'CCJ',
  'LDOS',
  'FSAKX',
  'FANUY',
  'K',
  'SLYV',
  'SLYG',
  'SWLGX',
  'OHI',
  'GBIL',
  'IBB',
  'BRO',
  'JMSIX',
  'TIBDX',
  'GNRC',
  'BINC',
  'ELF',
  'ENTG',
  'VMRXX',
  'PFFA',
  'BF.B',
  'CF',
  'FZROX',
  'VFH',
  'RDVY',
  'PDBC',
  'PSEC',
  'GLDM',
  'PAVE',
  'LKQ',
  'TOL',
  'VALE',
  'TPR',
  'ALNY',
  'IWY',
  'IUSV',
  'GEN',
  'SWTXX',
  'IWB',
  'RACE',
  'UBS',
  'STE',
  'DFQTX',
  'MANH',
  'VGSLX',
  'VRSN',
  'ONON',
  'TBCIX',
  'DFEM',
  'ICLN',
  'HALO',
  'PFG',
  'RKLB',
  'EFX',
  'SNA',
  'DLTR',
  'ZBRA',
  'BNPQY',
  'NTDOY',
  'GDDY',
  'CRSP',
  'IUSG',
  'DINO',
  'EXAS',
  'SPHY',
  'SGIIX',
  'STLD',
  'LKCO',
  'RIOT',
  'BN',
  'DFSV',
  'VDC',
  'HOLX',
  'BALL',
  'EXPD',
  'HII',
  'PRWCX',
  'OBDC',
  'LLDYX',
  'HAS',
  'WHR',
  'UPST',
  'NTR',
  'WRB',
  'MAS',
  'BRHYX',
  'VFIDX',
  'TOST',
  'CNP',
  'ALGN',
  'ALLY',
  'IHI',
  'CP',
  'PONPX',
  'CHRW',
  'TCEHY',
  'DRI',
  'MAA',
  'PSLIX',
  'STWD',
  'JQUA',
  'IDEV',
  'VVIAX',
  'TAP',
  'ISTB',
  'EADSY',
  'FSELX',
  'TXT',
  'IPG',
  'DECK',
  'CHPT',
  'QCVEZ',
  'VTIVX',
  'DFGR',
  'FSMAX',
  'PRWAX',
  'ITA',
  'BFFAX',
  'ARES',
  'QS',
  'AA',
  'VCLT',
  'ESCWX',
  'TRAIX',
  'SU',
  'VFIFX',
  'DEMIX',
  'HDEF',
  'CIBR',
  'HRL',
  'PTY',
  'TSCSX',
  'STT',
  'JVMIX',
  'VOD',
  'VEMAX',
  'DGX',
  'STLA',
  'PRCOX',
  'VPL',
  'CPB',
  'FAGIX',
  'HTGC',
  'USIG',
  'PKG',
  'IJK',
  'EME',
  'IJS',
  'FFIE',
  'APHJX',
  'NI',
  'HST',
  'GSINX',
  'MDY',
  'CPAY',
  'MDYV',
  'JCBUX',
  'JNK',
  'AVDE',
  'ICLR',
  'DFREX',
  'OXLC',
  'DPZ',
  'PTTRX',
  'HRB',
  'RIG',
  'BEN',
  'KMX',
  'SPIP',
  'FNSXX',
  'TDOC',
  'JBL',
  'PPRUY',
];
export default topTickerSymbols;
